import React from 'react';

class CalendarHeader extends React.Component {
    render() {
        return <div className="calendar-header">
            <button type="button" className="previous" aria-label={ this.props.previousText }
                onClick={ this.props.onPrevious }>
                <span></span>
            </button>
            <button type="button" className="text" disabled={ ( this.props.text ? false : true ) } 
                onClick={ this.props.onDrill }>
                <span>{this.props.text}</span>
            </button>
            <button type="button" className="next" aria-label={ this.props.nextText }
                onClick={ this.props.onNext }>
                <span></span>
            </button>
        </div>;
    }
}

export default CalendarHeader;
